import { useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import useAllMediaAdmin from "../../data/useAllMediaAdmin";
import useSocialScheduleSingle from "../../data/useSocialScheduleSingle";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import ConfirmDelete from "../Shared/ConfirmDelete";
import { ButtonInput } from "../Shared/Inputs/ButtonInput";
import LoadingWheel from "../Shared/LoadingWheel";
import AddEditSocialPostsModal from "./AddEditSocialPostsModal";
import AddEditScheduleModal from "./AddEditScheduleModal";


export default function ScheduleRowBox({ scheduleId, triggerType = "Evergreen" }) {
  const { agencyId } = useParams();
  const { socialSchedule, removeSchedule } = useSocialScheduleSingle(scheduleId);
  const { media } = useAllMediaAdmin(agencyId);
  const { deleteHandlers } = useDefaultCRUDHandlers("Social Schedule");
  const [isLoading, setIsLoading] = useState(true);
  const [addEditPostsOpen, setAddEditPostsOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [addEditScheduleOpen, setAddEditScheduleOpen] = useState(false);

  useEffect(() => {
    if (socialSchedule.data && !socialSchedule.isLoading && media.data && !media.isLoading) {
      setIsLoading(false);
    }
  }, [socialSchedule.data, socialSchedule.isLoading, media.data, media.isLoading])

  const showManagePosts = triggerType === "Evergreen" || triggerType === "Infographic" || triggerType === "Videos" || triggerType === "Schedule";

  const deleteSocialSchedule = () => {
    if (!scheduleId) return;

    removeSchedule.mutate(scheduleId, {
      onSuccess: () => {
        deleteHandlers.onSuccess();
        setDeleteOpen(false);
      },
      onError: deleteHandlers.onError,
    });
  };

  if (isLoading) {
    return (
      <div className="flex bg-white p-4 rounded-lg shadow-md justify-center items-center">
        <LoadingWheel width="w-10" height="h-10" /> 
      </div>
    )
  }

  return (
    <>
      <ConfirmDelete itemName={"Social Schedule"} open={deleteOpen} setOpen={setDeleteOpen} onConfirm={deleteSocialSchedule} />

      <AddEditScheduleModal open={addEditScheduleOpen} setOpen={setAddEditScheduleOpen} defaultTriggerType={triggerType} schedule={socialSchedule.data ?? {}} />
      <AddEditSocialPostsModal open={addEditPostsOpen} setOpen={setAddEditPostsOpen} schedule={socialSchedule?.data ?? {}} />

      <div className="bg-white p-4 rounded-lg shadow-md space-y-4">
        <div key={socialSchedule.data?.id} className="grid grid-cols-2">
          <div>
            <h2 className="text-lg font-semibold">{socialSchedule.data?.name}</h2>
            {/* <p className="text-sm text-gray-500">{socialSchedule.data?.id}</p> */}
            <p className="text-sm text-gray-500">{socialSchedule.data?.isActive ? "Active" : "Inactive"}</p>
            {showManagePosts && <p className="text-sm text-gray-500">{socialSchedule.data?.postData?.length} posts</p>}
          </div>
          <div className="flex justify-end items-start gap-x-2">
            <ButtonInput label="Edit" isSubmit={false} onClick={() => setAddEditScheduleOpen(true)} />
            <ButtonInput label="Delete" isSubmit={false} onClick={() => setDeleteOpen(true)} />
          </div>
        </div>

        <div>
          {showManagePosts && <ButtonInput label="Manage Posts" isSubmit={false} onClick={() => setAddEditPostsOpen(true)} />}
        </div>
      </div>

    </>
  )

}